module.exports = __webpack_public_path__ + "img/arthur-blank-students.df930ba7.jpg";